import React, { useState, useEffect } from "react";
import { MDBRow, MDBBtnGroup, MDBRadio } from "mdb-react-ui-kit";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Autocomplete from "@mui/material/Autocomplete";
import { Chip } from "@mui/material";
import close from "../../../images/header/close.png";
import iconn from "../../../images/next-left.png";
import AlertSuccess from "../../AlertSuccess/AlertSuccess";
import ButtonGroupBusinness from "../../ButtonGroupBusinness/ButtonGroupBusinness";
import ButtonGroupBusinness2 from "../../ButtonGroupBusinness/ButtonGroupBusinness2";
import { validate } from "../../../components/login/validate";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
// config
import configData from "../../../config/config.json";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const InformationStep4 = () => {
  const [dataCome, setDataCome] = useState(false);
  const [dataCome2, setDataCome2] = useState(false);

  // zakhire
  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  const [emptyInput, setemptyInput] = useState(true);
  const [changedCid, setChangedCid] = useState(true);

  // for api
  const [CatIdsApi, setCatIdsApi] = useState(null);
  const [ActiveApi, setActiveApi] = useState([]);

  const [items, setItems] = useState([]);

  // for button group
  const [showBtns, setShowBtns] = useState(false);

  const [disable, setDisable] = useState(false);

  const [categories, setCategories] = useState([]);
  const [cid, setcid] = useState([]);
  const [childCat, setChildCat] = useState([]);

  const [buttonGroupsId, setbuttonGroupsId] = useState([]);
  // console.log(buttonGroupsId);

  // group validate
  const [groupValidate, setGroupValidate] = useState(true);
  const [showGV, setShowGV] = useState(false);

  // validate
  const [data, setData] = useState({
    // objectValue: {},
    categoryy: "",
    inputValue: "",
  });
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const [list3, setList3] = useState([]);
  const listHandler = (newValue) => {
    if (list3.length < 3) {
      if (!list3.includes(newValue.title)) {
        setList3([...list3, newValue.title]);
      }
    }
  };

  const deleteHandler = (num) => {
    if (list3.length > 0) {
      setList3(list3.filter((item) => item !== num));
    }
    setValue(null);
    setData({ ...data, categoryy: "" });
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  //api header
  // const headerLoad = {
  //   ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
  //   LangId: 1,
  //   Parentid: cid,
  // };

  const [locakChild, setlocakChild] = useState(false);

  // api
  useEffect(() => {
    setDataCome(false);
    setDataCome2(false);

    axios
      .get(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/categories`,
        {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          let data = response.data.data;

          // set data to states
          let findCId = "";
          for (let index = 0; index < data.parentCat.length; index++) {
            const element = data.parentCat[index];
            setcid(element.cId);
            setList3([element.title]);
            setValue(element);

            findCId = element.cId;
          }
          setChildCat(data.childCat);
          setShowBtns(true);

          for (let i = 0; i < data.childCat.length; i++) {
            const element = data.childCat[i];
            if (element.isSelected) {
              setItems((items) => [...items, element.cId]);
            }
          }

          // api to get parent category data
          axios
            .get(configData.API_DOMAIN + "/api/v1/Categories", {
              headers: header,
            })
            .then((response) => {
              setDataCome(true);
              setDataCome2(true);

              if (response.data.isSuccess) {
                setCategories(response.data.data);

                if (findCId !== "") {
                  const findCat = response.data.data.find(
                    (item) => item.cId == findCId
                  );
                  setChildCat(findCat.children);
                }
              }
            })
            .catch((error) => {
              // alert(error);
            });
        }
      })
      .catch((error) => {
        // alert(error);
      });

    // load api by aidin
    // axios
    //   .get(domain + "/api/parentcate", {
    //     headers: headerLoad,
    //   })
    //   .then((response) => {
    //     if (response.data.msg == "done") {
    //       setCategories(response.data.CatList);
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
    // // }

    // axios
    //   .get(domain + "/api/biz/categories", { headers: header })
    //   .then((response) => {
    //     if (response.data.msg == "done") {
    //       // like step2

    //       setDataCome(true);
    //       setDataCome2(true);
    //       for (let index = 0; index < response.data.ParentCat.length; index++) {
    //         const element = response.data.ParentCat[index];
    //         setcid(element.CId);
    //         setList3([element.Title]);
    //         setValue(element);
    //       }
    //       setChildCat(response.data.ChildCat);
    //       setShowBtns(true);

    //       for (let i = 0; i < response.data.ChildCat.length; i++) {
    //         const element = response.data.ChildCat[i];
    //         if (element.IsSelected) {
    //           setItems((items) => [...items, element.CId]);
    //         }
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  }, []);

  useEffect(() => {
    if (locakChild) {
      setDataCome2(false);
      axios
        .get(configData.API_DOMAIN + "/api/v1/Categories", { headers: header })
        .then((response) => {
          if (response.data.isSuccess) {
            let data = response.data.data;
            const findCat = data.find((item) => item.cId == cid);
            setChildCat(findCat.children);
            setDataCome2(true);
          }
        })
        .catch((error) => {
          // alert(error);
        });
      setlocakChild(false);
    }
  }, [cid, changedCid]);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    // const itemsPost2 = getCookie("CatId");
    // // const itemsPost2 = JSON.parse(localStorage.getItem("CatId"));
    // var btnGroupsId = "";

    // if (buttonGroupsId.length == 0) {
    //   btnGroupsId = "";
    // } else if (buttonGroupsId.length == 1) {
    //   btnGroupsId = buttonGroupsId[0];
    // } else if (buttonGroupsId.length == 2) {
    //   btnGroupsId = buttonGroupsId[0] + "," + buttonGroupsId[1];
    // } else if (buttonGroupsId.length == 3) {
    //   btnGroupsId =
    //     buttonGroupsId[0] + "," + buttonGroupsId[1] + "," + buttonGroupsId[2];
    // }
    let btnGroupsId = "";

    const itemsPost2 = JSON.parse(localStorage.getItem("CatId"));

    if (buttonGroupsId.length == 0) {
      btnGroupsId = "";
    } else {
      for (let index = 0; index < buttonGroupsId.length; index++) {
        const element = buttonGroupsId[index];
        btnGroupsId = btnGroupsId + buttonGroupsId[index] + ",";
      }
    }
    const dataPost = {
      // ParentId: value.cId,
      // CatId: itemsPost2,
      // CatIds: btnGroupsId,
      // CatName: CatIdsApi,

      bId: getCookie("BizId"),
      parentId: value.cId,
      catIds: btnGroupsId,
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/categories`,
        dataPost,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success
          alertHandeler();
        }
      })
      .catch((error) => {
        // alert(error);
      });

    // save api by aidin
    // axios
    //   .post(domain + "/api/biz/ctegories-update", dataPost, {
    //     headers: header,
    //   })
    //   .then((response) => {
    //     setDisable(false);
    //     if (response.data.msg == "done") {
    //       // success
    //       alertHandeler();
    //     }
    //   })
    //   .catch((error) => {
    //     alert(error);
    //   });
  };

  return (
    <>
      <div className="part_four_info">
        <div className="step3_header"></div>

        <MDBRow className="mx-0">
          <div className="col-12 col-md-12 register-business-padd">
            <div className="step2_radio">
              <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                  <div dir="rtl" className="w-100">
                    {dataCome ? (
                      <>
                        <div className=" auto8 autoinformation width-sm-100 w-100">
                          <Autocomplete
                            value={value}
                            onChange={(event, newValue) => {
                              // console.log(changedCid);
                              setChangedCid(!changedCid);
                              setItems([]);
                              setbuttonGroupsId([]);
                              setValue(newValue);
                              setChildCat([]);
                              setlocakChild(true);
                              setcid(newValue.cId);
                              listHandler(newValue);
                              setShowBtns(true);
                              setData({
                                ...data,
                                categoryy: newValue.title,
                                // objectValue: newValue,
                              });

                              // setActiveApi([]);
                              // setbuttonGroupsId([]);
                              // // setCatIdsApi(null);
                              // setValue(newValue);
                              // setChildCat([]);
                              // setlocakChild(true);
                              // setcid(newValue.cId);
                              // listHandler(newValue);
                              // setShowBtns(true);
                              // setData({
                              //   ...data,
                              //   categoryy: newValue.Title,
                              //   // objectValue: newValue,
                              // });
                            }}
                            inputValue={inputValue}
                            onInputChange={(event, newInputValue) => {
                              setInputValue(newInputValue);
                              setData({ ...data, categoryy: newInputValue });
                            }}
                            disabled={list3.length > 0}
                            // open={true}
                            popupIcon={
                              <img
                                src={iconn}
                                className="icon-ib"
                                alt="category img"
                              />
                            }
                            disableClearable
                            disablePortal
                            openOnFocus={true}
                            id="auto8"
                            options={categories}
                            getOptionLabel={(option) => option.title}
                            className=""
                            sx={{
                              fontFamily: "inherit",
                            }}
                            renderInput={(params) => (
                              <div className="d-flex width-sm-100">
                                <TextField
                                  id="auto8"
                                  // className={
                                  //   errors.categoryy && touched.categoryy
                                  //     ? "auto-error"
                                  //     : ""
                                  // }
                                  {...params}
                                  label=" مثال: رستوران، وکالت،پزشکی"
                                  required
                                >
                                  {" "}
                                </TextField>
                              </div>
                            )}
                          />
                          {/* {errors.categoryy && touched.categoryy && (
                        <span className="input-error-auto me-1">
                          {errors.categoryy}
                        </span>
                      )} */}
                        </div>
                        {list3.map((item) => (
                          <Chip
                            id="rb-chip"
                            // dir="ltr"
                            label={item}
                            onDelete={() => {
                              if (list3.length == 1) {
                                deleteHandler(item);
                                setData({
                                  categoryy: "",
                                  // objectValue: {}
                                });
                                setShowBtns(false);
                              } else {
                                deleteHandler(item);
                              }
                            }}
                            deleteIcon={
                              <img
                                src={close}
                                alt="X"
                                className="s2-chip-icon"
                              />
                            }
                            key={item}
                          />
                        ))}
                      </>
                    ) : (
                      <>
                        <Skeleton
                          className="radius2"
                          variant="rectangular"
                          height={30}
                          animation="wave"
                        />
                        <Skeleton
                          id="rb-chip"
                          className="bg-skeleton"
                          variant="rectangular"
                          // height={20}
                          width={170}
                          animation="wave"
                        />
                      </>
                    )}
                    {dataCome2 ? (
                      <div className={showBtns ? "d-block " : "d-none"}>
                        {/* second part */}
                        {/* <ButtonGroupBusinness2
                        ActiveApi={ActiveApi}
                        data={childCat}
                        buttonGroupsId={buttonGroupsId}
                        onChangebuttonGroupsId={setbuttonGroupsId}
                        groupValidate={groupValidate}
                        setGroupValidate={setGroupValidate}
                        showGV={showGV}
                        CatIdsApi={CatIdsApi}
                        setCatIdsApi={setCatIdsApi}
                      /> */}

                        {childCat.length > 0 && (
                          <ButtonGroupBusinness
                            itemss={items}
                            data={childCat}
                            buttonGroupsId={buttonGroupsId}
                            onChangebuttonGroupsId={setbuttonGroupsId}
                            groupValidate={groupValidate}
                            setGroupValidate={setGroupValidate}
                            showGV={showGV}
                            CatIdsApi={CatIdsApi}
                            setCatIdsApi={setCatIdsApi}
                            emptyInput={emptyInput}
                            setemptyInput={setemptyInput}
                          />
                        )}
                      </div>
                    ) : (
                      <>
                        <div className="d-flex justify-content-center justify-content-md-start mt-5 px-0">
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                        </div>
                        <div className="d-flex justify-content-center justify-content-md-start px-0">
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                          <Skeleton
                            id="rb-chip"
                            className="bg-skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            width={100}
                            animation="wave"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </ThemeProvider>
              </CacheProvider>
            </div>
          </div>

          <div className=" step2_save_c p-0">
            {dataCome ? (
              <button
                onClick={submitHandler}
                disabled={disable}
                className="btn_information_submit"
              >
                ذخیره اطلاعات
              </button>
            ) : (
              <Skeleton
                className="btn_information_submit me-auto"
                variant="rectangular"
                height={39}
                animation="wave"
              />
            )}
          </div>
        </MDBRow>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
    </>
  );
};

export default InformationStep4;
